// Three lists of 50 celebrity names each (Easy, Medium, Hard)
// Names chosen to be well-known across domains; Hard list contains less-mainstream
// but still notable public figures.

export const EasyCelebs = [
  "Taylor_Swift",
  "Beyoncé",
  "Dwayne_Johnson",
  "Oprah_Winfrey",
  "Brad_Pitt",
  "Angelina_Jolie",
  "Leonardo_DiCaprio",
  "Tom_Cruise",
  "Jennifer_Lawrence",
  "Rihanna",
  "Kanye_West",
  "Ariana_Grande",
  "Kylie_Jenner",
  "Selena_Gomez",
  "Ellen_DeGeneres",
  "Will_Smith",
  "Justin_Bieber",
  "Kim_Kardashian",
  "Chris_Hemsworth",
  "Scarlett_Johansson",
  "Robert_Downey_Jr.",
  "Emma_Watson",
  "Lady_Gaga",
  "Sandra_Bullock",
  "Johnny_Depp",
  "Chris_Evans_(actor)",
  "Margot_Robbie",
  "Jennifer_Aniston",
  "Serena_Williams",
  "LeBron_James",
  "Stephen_King",
  "Meryl_Streep",
  "Gal_Gadot",
  "Katy_Perry",
  "Shakira",
  "Ed_Sheeran",
  "Adele",
  "Kendrick_Lamar",
  "Post_Malone",
  "Billie_Eilish",
  "Drake_(musician)",
  "Tina_Fey",
  "Adam_Sandler",
  "Tom_Hanks",
  "Keanu_Reeves",
  "Natalie_Portman",
  "Harrison_Ford",
  "Zendaya",
  "Michael_Jordan",
  "Oprah_Winfrey",
];

export const MediumCelebs = [
  "Rami_Malek",
  "Florence_Pugh",
  "Timothée_Chalamet",
  "Mahershala_Ali",
  "Saoirse_Ronan",
  "John_Boyega",
  "Lakeith_Stanfield",
  "Cillian_Murphy",
  "Tessa_Thompson",
  "Zoe_Saldana",
  "Viola_Davis",
  "Octavia_Spencer",
  "Daniel_Kaluuya",
  "Idris_Elba",
  "Brie_Larson",
  "Janelle_Monáe",
  "Eddie_Redmayne",
  "Rachel_Weisz",
  "Jon_Hamm",
  "Ewan_McGregor",
  "Anya_Taylor-Joy",
  "Jamie_Dornan",
  "Mahesh_Babu",
  "Gugu_Mbatha-Raw",
  "Domhnall_Gleeson",
  "Alicia_Vikander",
  "Pedro_Pascal",
  "Benicio_Del_Toro",
  "Naomi_Watts",
  "Heather_Graham",
  "Ben_Affleck",
  "Rosamund_Pike",
  "Mark_Ruffalo",
  "Paul_Dano",
  "Greta_Gerwig",
  "Claire_Foy",
  "Maggie_Gyllenhaal",
  "Taron_Egerton",
  "Saoirse_Ronan",
  "Joaquin_Phoenix",
  "Jenny_Slate",
  "Peter_Dinklage",
  "Danai_Gurira",
  "Lupita_Nyongo",
  "Cillian_Murphy",
  "Kirsten_Dunst",
  "Rosario_Dawson",
  "Gillian_Anderson",
  "Hugh_Dancy",
  "Rebecca_Hall",
];

export const HardCelebs = [
  "Tilda_Swinton",
  "Willem_Dafoe",
  "Isabelle_Huppert",
  "Rinko_Kikuchi",
  "David_Byrne",
  "Arundhati_Roy",
  "Sufjan_Stevens",
  "Maggie_Smith",
  "Julianne_Moore",
  "Sam_Shepard",
  "Morrissey",
  "Patti_Smith",
  "Elliott_Smith",
  "Daniel_Day-Lewis",
  "Chiwetel_Ejiofor",
  "Parker_Posey",
  "Lena_Dunham",
  "Mads_Mikkelsen",
  "Toni_Morrison",
  "Hanif_Kureishi",
  "Claire_Denis",
  "Claire_Danes",
  "Wes_Anderson",
  "Yorgos_Lanthimos",
  "Apichatpong_Weerasethakul",
  "Lucrecia_Martel",
  "Agnès_Varda",
  "Terence_Davies",
  "Kelly_Reichardt",
  "Miranda_July",
  "Don_DeLillo",
  "Kazuo_Ishiguro",
  "Zadie_Smith",
  "Björk",
  "Gustav_Klimt",
  "Anselm_Kiefer",
  "Marina_Abramović",
  "Glenn_Gould",
  "Arvo_Pärt",
  "Peter_Greenaway",
  "John_Cassavetes",
  "Cass_McCombs",
  "Nick_Cave",
  "Tom_Waits",
  "Joan_Didion",
  "Samantha_Morton",
  "Charlotte_Rampling",
  "Isabel_Coixet",
  "Hirokazu_Kore-eda",
];

export default { EasyCelebs, MediumCelebs, HardCelebs };
